import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { LoyaltyService, LoyaltyServiceImpl } from 'entities/Loyalty';

function initLoyaltyService(client: ApolloClient<NormalizedCacheObject>): LoyaltyService {
  return new LoyaltyServiceImpl(client);
}

export default initLoyaltyService;
